import { useEffect } from 'react';

import styles from './bip.module.scss';
import type { TStyleWrapper } from './type';

export const BipStylesWrapper = ({ children }: TStyleWrapper) => {
  useEffect(() => {
    const portalElement = document.querySelector('div[sr-portal-container]');
    const nextElement = document.querySelector('#__next');

    portalElement?.classList?.add(styles.common);
    nextElement?.classList.add(styles.next);
  }, []);

  return <div className={styles.common}>{children}</div>;
};
